var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.00854H10M2 4.00854H14M12.6667 4.00854L12.1991 11.0214C12.129 12.0736 12.0939 12.5997 11.8667 12.9985C11.6666 13.3497 11.3648 13.6321 11.0011 13.8083C10.588 14.0085 10.0607 14.0085 9.00623 14.0085H6.99377C5.93927 14.0085 5.41202 14.0085 4.99889 13.8083C4.63517 13.6321 4.33339 13.3497 4.13332 12.9985C3.90607 12.5997 3.871 12.0736 3.80086 11.0214L3.33333 4.00854M6.66667 7.00855V10.3419M9.33333 7.00855V10.3419",
    stroke: "#FF0000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.a8d99a5e898025b7aef0e93b6f77c58f.svg";
export { ForwardRef as ReactComponent };